module.exports = __webpack_public_path__ + "img/symbol_1.ab0956c7.png";